var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9375 31.5C39.6451 31.5 39.3301 31.455 39.0376 31.365C38.478 31.176 37.9922 30.8157 37.6489 30.3351C37.3056 29.8545 37.1223 29.2781 37.125 28.6875V24.7275C33.975 24.435 31.5 21.78 31.5 18.5625V10.6875C31.5 7.2675 34.2676 4.5 37.6875 4.5H52.3125C55.7326 4.5 58.5 7.2675 58.5 10.6875V18.5625C58.5 21.9825 55.7326 24.75 52.3125 24.75H46.4175L42.1875 30.375C41.6475 31.095 40.8151 31.5 39.9375 31.5ZM21.3751 37.125C18.8407 37.1191 16.4119 36.1097 14.6199 34.3176C12.8279 32.5256 11.8185 30.0968 11.8126 27.5625C11.8185 25.0282 12.8279 22.5994 14.6199 20.8074C16.4119 19.0153 18.8407 18.0059 21.3751 18C23.9094 18.0059 26.3382 19.0153 28.1302 20.8074C29.9222 22.5994 30.9316 25.0282 30.9375 27.5625C30.9316 30.0968 29.9222 32.5256 28.1302 34.3176C26.3382 36.1097 23.9094 37.1191 21.3751 37.125ZM7.8098 53.82C10.7573 56.925 15.3248 58.5 21.3773 58.5C27.4298 58.5 31.9973 56.925 34.9448 53.82C38.3693 50.1975 38.259 45.8257 38.2523 45.531V45.5175C38.2523 42.75 36.0023 40.5 33.2348 40.5H9.5198C6.7523 40.5 4.5023 42.75 4.5023 45.4275V45.4567C4.4933 45.8842 4.4078 50.22 7.8098 53.82Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.52bf66c3d823d3134a0354a687e2a211.svg";
export { ForwardRef as ReactComponent };